module.exports = __webpack_public_path__ + "static/water_glacier18-7e4b0d10fcb182d7e5a35e587f3fd1af.jpg";